import React from 'react';

import { TradeButton } from '../c/Trade';
import AddToPortfolio from '../c/AddToPortfolio';
import CollectionChecker from '../c/CollectionChecker';
import { RangedChart, LargeChartInner } from '../c/Chart';
import LogoAndInfo from '../c/LogoAndInfo';

function LargeStockChart(props) {
	const info = <LogoAndInfo exchange={props.exchange} ticker={props.ticker}/>
	return <RangedChart range_in="query" type="stock" info={info} inner={LargeChartInner} {...props}/>
}

function Ticker(props) {
	return (
		<div>
			<LargeStockChart exchange={props.exchange} ticker={props.ticker}/>
			<div className="px-3">
				<TradeButton exchange={props.exchange} ticker={props.ticker}/>
				<CollectionChecker exchange={props.exchange} ticker={props.ticker}/>
				<AddToPortfolio exchange={props.exchange} ticker={props.ticker}/>
				<div className="pb-5">
					&nbsp;
				</div>
			</div>
		</div>
	);
}
export default Ticker;



// WEBPACK FOOTER //
// ./src/p/Ticker.js